import CollapseArrowIcon from "@assets/icons/collapseArrowIcon";
import { PolicyEnum } from "@config/policyEnum";
import { useHasPolicy } from "@config/useHasPolicy";
import {
  Box,
  Card,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";

interface UserOrganizationAddressProps {
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | { value: string; name: string }>
  ) => void;
  updateUserInfo:boolean,
}
const UserOrganizationAddress: React.FC<UserOrganizationAddressProps> = ({
  handleChange,
  updateUserInfo,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showBasicInformation, setShowBasicInformation] = useState(true);
  const { addressLine1, addressLine2, city, state, zipcode, countryName } =
    useSelector((state: any) => state.user);

  const handleCollapse = () => {
    setShowBasicInformation(!showBasicInformation);
  };
  const showProfileAddressLine = useHasPolicy(PolicyEnum.VIEW_PROFILE_ADDRESS_LINE); 
  const showProfileApartment = useHasPolicy(PolicyEnum.VIEW_PROFILE_USER_APARTMENT); 
  const showProfileCity = useHasPolicy(PolicyEnum.VIEW_PROFILE_USER_CITY); 
  const showProfileState = useHasPolicy(PolicyEnum.VIEW_PROFILE_USER_STATE); 
  const showProfileZipCode = useHasPolicy(PolicyEnum.VIEW_PROFILE_ZIPCODE); 
  const showProfileCountry = useHasPolicy(PolicyEnum.VIEW_PROFILE_USER_COUNTRY); 
  // const editProfileAddressLine = useHasPolicy(PolicyEnum.EDIT_PROFILE_ADDRESS_LINE);
  // const editProfileApartment = useHasPolicy(PolicyEnum.EDIT_PROFILE_USER_APARTMENT);
  // const editProfileCity = useHasPolicy(PolicyEnum.EDIT_PROFILE_USER_CITY);
  // const editProfileState = useHasPolicy(PolicyEnum.EDIT_PROFILE_USER_STATE);
  // const editProfileZipCode = useHasPolicy(PolicyEnum.EDIT_PROFILE_ZIPCODE);
  // const editProfileCountry = useHasPolicy(PolicyEnum.EDIT_PROFILE_USER_COUNTRY);

  return (
    <>
    {(showProfileAddressLine || showProfileApartment || showProfileCity || showProfileState || showProfileZipCode || showProfileCountry) &&
    <Card className="mt-4  md:mt-2 md:!shadow-none">
      <Box className=" hidden md:flex md:items-center bg-[#F2F2F2]">
        <Typography
          sx={{
            padding: "0.5rem 0.5rem 0.5rem 1rem",
            fontWeight: "500",
          }}
        >
          Organization Address
        </Typography>
      </Box>
      <Box
        className="flex justify-between items-center border-b-2 md:hidden"
        onClick={handleCollapse}
      >
        <Box className="flex items-center">
          <Typography
            sx={{
              padding: "0.5rem 0.5rem 0.5rem 1rem",
              backgroundColor: { xs: "#fff", sm: "#F2F2F2" },
              fontWeight: "400",
            }}
          >
            Organization Address
          </Typography>
        </Box>
        <Typography className="pr-3">
          <CollapseArrowIcon />
        </Typography>
      </Box>
      {(showBasicInformation || !isMobile) && (
        <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 p-4">
          {showProfileAddressLine &&
          <Box className="flex flex-col ">
            <Typography variant="body1">
              Address Line #1 <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="address"
              placeholder="Enter Address Line #1"
              value={addressLine1}
              size="small"
              onChange={handleChange}
              disabled
            />
          </Box>}
          {showProfileApartment &&
          <Box className="flex flex-col">
            <Typography variant="body1">
              Suite, Apartment, etc <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="apartment"
              placeholder="Enter Street"
              size="small"
              value={addressLine2}
              onChange={handleChange}
              disabled
            />
          </Box>}
          {showProfileCity &&
          <Box className="flex flex-col">
            <Typography variant="body1">
              City <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="city"
              placeholder="Enter City"
              size="small"
              value={city}
              onChange={handleChange}
              disabled
            />
          </Box>}
          {showProfileState &&
          <Box className="flex flex-col">
            <Typography variant="body1">
              State/County <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="state"
              placeholder="Select State"
              size="small"
              value={state}
              onChange={handleChange}
              disabled
            />
          </Box>}
          {showProfileZipCode &&
          <Box className="flex flex-col">
            <Typography variant="body1">
              Zip code/Postal code <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="zipcode"
              placeholder="Enter Zip Code"
              size="small"
              value={zipcode}
              onChange={handleChange}
              disabled
            />
          </Box>}
          {showProfileCountry &&
          <Box className="flex flex-col">
            <Typography variant="body1">
              Country <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="country"
              placeholder="Enter Country"
              size="small"
              value={countryName}
              onChange={handleChange}
              disabled
            />
          </Box>}
        </Box>
      )}
    </Card>}
    </>
  );
};

export default UserOrganizationAddress;
